import React from "react";
import { Row, Col } from "reactstrap";
import { ArrowRightIcon, DateIcon } from "../../components/Icons";
import { Link } from 'react-router-dom';
import './News.css';

export default class NewsSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'News',
            hideViewAllButton: props.hideViewAllButton,
            isAnnouncementLoading: true,
            isNewsLoading: true,
            isResearchLoading: true,
            announcementList: [],
            newsList: [],
            researchList: []
        }
    }

    async loadContent(url) {
        try {
            const response = await fetch(url);
            const data = await response.json();
            return data;
        }
        catch {
            console.log("Error");
            return [];
        }
    }

    async loadAnnouncements() {
        var url = 'api/Content/GetAllAnnouncements';
        var result = await this.loadContent(url);
        this.setState({ announcementList: result, isAnnouncementLoading: false });
    }

    async loadNews() {
        var url = 'api/Content/GetAllNews';
        var result = await this.loadContent(url);
        this.setState({ newsList: result, isNewsLoading: false });
    }

    async loadResearchs() {
        var url = 'api/Content/GetAllResearchs';
        var result = await this.loadContent(url);
        this.setState({ researchList: result, isResearchLoading: false });
    }

    async componentDidMount() {
        this.loadAnnouncements();
        this.loadNews();
        this.loadResearchs();

        if(this.props.activeTab) {
            this.setState({ activeTab: this.props.activeTab});
        }
    }

    renderAnnouncements(announcementList, isLoading, targetSymbol) {
        if (isLoading) {
            return <p><em>Loading Announcement...</em></p>;
        }
        var isEverySymbol = targetSymbol === "EVERY_SYMBOL";
        return announcementList.map(i => <div key={`announcement-${i.slug}`} className="news" style={{ display: new Set(i.relatedSymbol).has(targetSymbol) || isEverySymbol ? '' : 'none' }}>
            <div>
                <p className="news-title">
                    <Link to={`/Content/Announcements/${i.slug}`}>{i.title}</Link>
                </p>
                <p className="news-date"><DateIcon /> {i.dateString} </p>
            </div>
        </div>);
    }

    renderNews(newsList, isLoading, targetSymbol) {
        if (isLoading) {
            return <p><em>Loading News...</em></p>;
        }
        var isEverySymbol = targetSymbol === "EVERY_SYMBOL";
        return newsList.map(i => <div key={`news-${i.slug}`} className="news" style={{ display: new Set(i.relatedSymbol).has(targetSymbol) || isEverySymbol ? '' : 'none' }}>
            <div>
                <Link to={`/Content/News/${i.slug}`}>
                    <img src={`${i.titleImageUrl}`} alt="" style={{ height: '55px', width: '55px' }} />
                </Link>
            </div>
            <div>
                <p className="news-title">
                    <Link to={`/Content/News/${i.slug}`}>{i.title}</Link>
                </p>
                <p className="news-date"><DateIcon /> {i.dateString} </p>
            </div>
        </div>);
    }

    renderResearch(researchList, isLoading, targetSymbol) {
        if (isLoading) {
            return <p><em>Loading Research...</em></p>;
        }
        var isEverySymbol = targetSymbol === "EVERY_SYMBOL";
        return researchList.map(i => <div key={`research-${i.slug}`} className="news" style={{ display: new Set(i.relatedSymbol).has(targetSymbol) || isEverySymbol ? '' : 'none' }}>
            <div>
                <Link to={`/Content/Researchs/${i.slug}`}>
                    <img src={`${i.titleImageUrl}`} alt="" className="icon_img" style={{ height: '55px', width: '55px' }} />
                </Link>
            </div>
            <div>
                <p className="news-title">
                    <Link to={`/Content/Researchs/${i.slug}`}>{i.title}</Link>
                </p>
                <p className="news-date"><DateIcon /> {i.dateString} </p>
            </div>
        </div>);
    }

    render() {
        var { activeTab, hideViewAllButton } = this.state;
        return <div id="news-box" className={`round-box ${this.props.className}`}>
            {hideViewAllButton === true || <Row>
                <Col className="round-box-title">ข่าวสาร</Col>
                <Col className="align-right"> <Link className="btn-view-all" to={'/Contents'}>ดูทั้งหมด <ArrowRightIcon /> </Link> </Col>
            </Row>}
            {this.props.showTabs !== false && <Row>
                <Col>
                    <div className="round-box-tabs">
                        <button onClick={() => this.setState({ activeTab: 'News' })} className={activeTab === 'News' ? "active" : ""}>ข่าว</button>
                        <button onClick={() => this.setState({ activeTab: 'Research' })} className={activeTab === 'Research' ? "active" : ""}>บทวิเคราะห์</button>
                        <button onClick={() => this.setState({ activeTab: 'Announcement' })} className={activeTab === 'Announcement' ? "active" : ""}>ประกาศ</button>                        
                    </div>
                </Col>
            </Row>}
            {activeTab === 'News' && <div className="news-layout-one news-container">
                {this.renderNews(this.state.newsList, this.state.isNewsLoading, this.props.targetSymbol)}
            </div>}
            {activeTab === 'Research' && <div className="news-layout-one news-container">
                {this.renderResearch(this.state.researchList, this.state.isResearchLoading, this.props.targetSymbol)}
            </div>}
            {activeTab === 'Announcement' && <div className="news-layout-two news-container">
                {this.renderAnnouncements(this.state.announcementList, this.state.isAnnouncementLoading, this.props.targetSymbol)}
            </div>}           
        </div>
    }
}